import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  timeout: 30000,
  withCredentials: true, // send session_token cookie on every request
});

export default http;

// ---- Auth ----
export const authMe = () => http.get("/auth/me").then((r) => r.data);
export const authSession = (session_id) =>
  http.post("/auth/session", { session_id }).then((r) => r.data);
export const authGuest = () => http.post("/auth/guest").then((r) => r.data);
export const authLogout = () => http.post("/auth/logout").then((r) => r.data);

// ---- Recces ----
export const listRecces = (archived = false) =>
  http.get("/recces", { params: { archived } }).then((r) => r.data);
export const getRecce = (id) => http.get(`/recces/${id}`).then((r) => r.data);
export const createRecce = (payload) => http.post("/recces", payload).then((r) => r.data);
export const rescout = (id) => http.post(`/recces/${id}/rescout`).then((r) => r.data);
export const deleteRecce = (id) => http.delete(`/recces/${id}`).then((r) => r.data);
export const markSeen = (id) => http.post(`/recces/${id}/seen`).then((r) => r.data);
export const archiveRecce = (id, archived) =>
  http.patch(`/recces/${id}/archive`, { archived }).then((r) => r.data);
export const togglePause = (id) =>
  http.post(`/recces/${id}/pause`).then((r) => r.data);
export const updateDraft = (id, draft) =>
  http.patch(`/recces/${id}/draft`, { draft }).then((r) => r.data);
export const uploadSketch = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return http
    .post(`/recces/${id}/sketch`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 90000,
    })
    .then((r) => r.data);
};
export const removeSketch = (id) =>
  http.delete(`/recces/${id}/sketch`).then((r) => r.data);
export const getDigest = () => http.get("/digest").then((r) => r.data);
export const getMyCredits = () => http.get("/me/credits").then((r) => r.data);
export const getOwnerStats = () => http.get("/stats").then((r) => r.data);
export const sendFeedback = (message, page = "") =>
  http.post("/feedback", { message, page }).then((r) => r.data);
export const toggleStar = (refId) =>
  http.patch(`/references/${refId}/star`).then((r) => r.data);
export const deleteReference = (refId) =>
  http.delete(`/references/${refId}`).then((r) => r.data);
export const toggleWatch = (id, watching, interval_hours = 24) =>
  http
    .patch(`/recces/${id}/watch`, { watching, interval_hours })
    .then((r) => r.data);
export const setReferenceFeedback = (refId, feedback) =>
  http.patch(`/references/${refId}/feedback`, { feedback }).then((r) => r.data);
export const setMyTimezone = (tz) =>
  http.patch("/me/timezone", { timezone: tz }).then((r) => r.data);
export const adminSetPlan = (user_id, plan) =>
  http.post("/admin/plan", { user_id, plan }).then((r) => r.data);
export const enableShare = (id) =>
  http.post(`/recces/${id}/share`).then((r) => r.data);
export const disableShare = (id) =>
  http.delete(`/recces/${id}/share`).then((r) => r.data);
// Public share — hits the no-auth endpoint, so we use axios without the
// withCredentials cookie jar (no need to send session_token to a public URL).
export const getPublicShare = (token) =>
  axios.get(`${API}/public/share/${token}`, { timeout: 15000 }).then((r) => r.data);
